import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { UIRootState } from '../../store/reducers';
import { closeSettingsModal } from '../../store/actions/gameUIActions';

export const SettingsModal: React.FC = () => {
  const dispatch = useDispatch();
  const settings = useSelector((state: UIRootState) => state.gameUI.settings);
  const labels = useSelector((state: UIRootState) => state.gameUI.labels);


  const handleButtonClick = (buttonKey: string, data?: any) => {
    console.log('⚙️ SettingsModal handleButtonClick:', buttonKey, data);
    document.dispatchEvent(new CustomEvent('ui-button-click', {
      detail: { buttonKey, data }
    }));
  };

  const handleSettingChange = (settingKey: string) => {
    console.log('⚙️ React: User clicked setting:', settingKey);
    console.log('⚙️ React: Current settings from store:', settings);
    document.dispatchEvent(new CustomEvent('ui-setting-change', {
      detail: { settingKey }
    }));
  };

  useEffect(() => {
    const handleUIEvent = (event: CustomEvent) => {
      const detail = event.detail;
      if (detail.buttonKey === 'close-settings') {
        dispatch(closeSettingsModal());
      }
      // Feedback button is handled directly by GameUI, no need to handle it here
    };

    document.addEventListener('ui-button-click', handleUIEvent as EventListener);
    return () => document.removeEventListener('ui-button-click', handleUIEvent as EventListener);
  }, [dispatch]);

  // GameUI handles 'ui-setting-change' events directly, no need to duplicate here

  return (
    <div 
      id="game-ui-options" 
      className="text-white flex-column h-100 w-100"
      style={{
        background: 'rgb(31, 31, 31, 0.3)',
        position: 'absolute',
        top: 0,
        display: 'none',
        opacity: 0,
        bottom: 0,
        padding: '7px 22px 15px 25px'
      }}
    >
      <div className="game-ui-options-content-wrapper" style={{
        top: 0,
        position: 'absolute',
        right: 0,
        left: 0,
        height: '100%',
        maxWidth: '400px',
        margin: '0 auto',
        padding: '7px 22px 15px 25px'
      }}>
        {/* Header */}
      <div className="d-flex justify-content-between align-items-center mb-4" style={{ paddingTop: '20px' }}>
        <h5 id="settings-header" style={{ fontWeight: 600, fontSize: '22px' }} className="mb-0 text-white">{labels.settingsText}</h5>
        <button 
          id="closeOptionsButton" 
          className="btn btn-link text-white p-0 border-0" 
          style={{ opacity: 0.6 }}
          onClick={() => handleButtonClick('close-settings')}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="currentColor"/>
          </svg>
        </button>
      </div>

      {/* Dynamic Settings Options */}
      <div id="dynamic-checkboxes" className="d-flex flex-column checkboxes" style={{ marginTop: '48px' }}>
        {settings.map((setting) => (
          setting.visible && (
            <div 
              key={setting.key}
              className="checkbox-item"
              data-setting-key={setting.key}
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                height: '64px'
              }}
            >
              <div 
                className="checkbox-content"
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  width: '100%',
                  alignItems: 'center'
                }}
              >
                <span className="checkbox-label" style={{ color: 'white' }}>
                  {setting.label}
                </span>
                <div className="form-check form-switch" style={{ marginRight: '15px' }}>
                  <input
                    id={`dynamicCheckbox_${setting.key}`}
                    type="checkbox"
                    checked={setting.checked}
                    onChange={() => handleSettingChange(setting.key)}
                    className="form-check-input"
                    style={{
                      width: '55px',
                      height: '28px',
                      backgroundColor: setting.checked ? '#28a745' : '#6c757d',
                      borderColor: setting.checked ? '#28a745' : '#6c757d',
                      cursor: 'pointer'
                    }}
                  />
                </div>
              </div>
              <div 
                className="divider-secondary"
                style={{
                  width: '96%',
                  height: '1px',
                  background: 'gray',
                  marginTop: '16px',
                  marginRight: 'auto'
                }}
              />
            </div>
          )
        ))}
      </div>

      {/* Feedback Button */}
      <div 
        id="feedbackButton" 
        className="d-flex align-items-center justify-content-center"
        onClick={() => handleButtonClick('feedback')}
        style={{
          gap: '8px',
          color: 'white',
          fontSize: '14px',
          fontWeight: 400,
          cursor: 'pointer',
          transition: 'opacity 0.3s ease',
          padding: '8px 0',
          position: 'absolute',
          bottom: '12px',
        }}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path fillRule="evenodd" clipRule="evenodd" d="M3 3H21C22.1 3 23 3.9 23 5V17C23 18.1 22.1 19 21 19H13.9L10.2 21.7C10 21.9 9.7 22 9.5 22H9C8.4 22 8 21.6 8 21V19H3C1.9 19 1 18.1 1 17V5C1 3.9 1.9 3 3 3ZM6 7C5.44772 7 5 7.44772 5 8C5 8.55228 5.44772 9 6 9H18C18.5523 9 19 8.55228 19 8C19 7.44772 18.5523 7 18 7H6ZM6 12C5.44772 12 5 12.4477 5 13C5 13.5523 5.44772 14 6 14H18C18.5523 14 19 13.5523 19 13C19 12.4477 18.5523 12 18 12H6Z" fill="white"/>
        </svg>
                  <span id="feedback-button-text">{labels.feedbackText}</span>
      </div>
      </div>
      

      {/* Inline styles для совместимости с tmp */}
      <style>{`
        .form-check-input:checked {
          background-color: #28a745 !important;
          border-color: #28a745 !important;
        }
        
        .form-check-input:not(:checked) {
          background-color: #6c757d !important;
          border-color: #6c757d !important;
        }

        .form-check-input {
          outline: none;
          --bs-form-switch-bg: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3.5' fill='%23fff'/%3e%3c/svg%3e") !important;
        }
        
        .form-check-input:focus {
          border-color: none !important;
          box-shadow: none !important;
          --bs-form-switch-bg: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3.5' fill='%23fff'/%3e%3c/svg%3e") !important;
        }

        .checkbox-item.hidden {
          display: none !important;
        }

        #feedbackButton:hover {
          opacity: 0.7 !important;
        }

        #feedbackButton:active {
          opacity: 0.5 !important;
        }
      `}</style>
    </div>
  );
}; 